import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Typography } from 'antd';
import { ReportsDataStore } from 'stores';

const { Title } = Typography;

const Span = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-size: 1rem;
`;

const DateRangeBasedTitle = ({ titlePrefix }) => {
  return (
    <>
      <Title level={3}>
        {titlePrefix}{' '}
        <Span>
          in the Past {ReportsDataStore.currentSelectedDateRangeDescription}
        </Span>
      </Title>
    </>
  );
};

DateRangeBasedTitle.propTypes = {
  titlePrefix: PropTypes.string,
};

DateRangeBasedTitle.defaultProps = {
  titlePrefix: '',
};

export default DateRangeBasedTitle;
